import { all, takeEvery, fork, put, select, call } from 'redux-saga/effects'
import actions from './actions'
import {
    getListEventAPI,
    createNewEventAPI,
    getEventbyIdAPI,
    updateEventbyIdAPI,
    deleteEventbyIdAPI,
    getListEventQuery,
    getDataExtEvent
} from '../../services/apis/EventAPIServices'
import { searchEvent } from '../../services/apis/SearchService'
import { getUserById } from '../../services/apis/UserAPIServices'
// storage
import { setLocalData, getLocalData } from '../../services/StorageServices'
import { notification } from 'antd'
import { HandleErrorCode } from '../handleErrorCode'
import scrumBoardActions from '../../redux/scrumBoard/actions'

function* saga_searchEventByText(action) {
    try {
        const { page_number, page_size, text, status, begin_time, end_time, type_search } = action.payload

        const resquest = yield call(
            searchEvent,
            page_number,
            page_size,
            (text),
            status,
            begin_time, end_time, type_search
        )
        console.log('data search event', resquest)
        if (resquest.error.code === 200) {
            yield put(
                actions.action.searchEventByTextDone(
                    resquest.data,
                    resquest.total
                )
            )
        } else {
            yield put(actions.action.searchEventByTextDone([], 0))
        }
    } catch (ex) {
        console.log('search Event  Error : ', ex.message)
    }
}

function* saga_getOwnerInfo(action) {
    try {
        const { id } = action.payload

        const resquest = yield call(getUserById, id)
        if (resquest.error.code === 200) {
            yield put(actions.action.getOwnerInfoEventDone(resquest.data))
        }
    } catch (ex) {
        console.log('get owwner Event  Error : ', ex.message)
    }
}

function* saga_getListEvent(action) {
    try {
        const { page_number, page_size, deleted } = action.payload

        const resquest = yield call(
            getListEventAPI,
            page_number,
            page_size,
            deleted
        )
        if (resquest.error.code === 200) {
            yield put(
                actions.action.getListEventDone(resquest.data, resquest.total)
            )
        }
    } catch (ex) {
        console.log('getListEvent Error : ', ex.message)
    }
}
function* saga_getEventById(action) {
    try {
        const { eid } = action.payload

        const resquest = yield call(getEventbyIdAPI, eid)
        console.log('respone get event by id', resquest)
        if (resquest.error.code === 200) {
            yield put(actions.action.getEventByIdDone(resquest.data))
            yield put(actions.action.visibleEditModal(true))
            let reqGetExt = yield call(getDataExtEvent, resquest.data.event_id);
            if (reqGetExt.error.code === 200) {
                yield put(scrumBoardActions.applyToMedia(reqGetExt.media_ext))
                yield put(scrumBoardActions.applyToMedia(reqGetExt.media_ext))
                yield put(scrumBoardActions.applyToCurrentObject(reqGetExt.obj_ext))

            }
        }
    } catch (ex) {
        console.log('getEventById Error : ', ex.message)
    }
}
function* saga_EditEvent(action) {
    try {
        const { eid, body } = action.payload

        const resquest = yield call(updateEventbyIdAPI, eid, body)
        console.log('body edit event', body)
        console.log('respone update event by id', resquest)
        if (resquest.error.code === 200) {
            yield put(actions.action.getListEvent(1, 10, 0))
            yield put(actions.action.visibleEditModal(false))
            notification.success({
                message: 'Sửa sự kiện thành công',
            })
        } else {
            HandleErrorCode(resquest.error.code)
        }
    } catch (ex) {
        console.log('updateEventById Error : ', ex.message)
    }
}
function* saga_DeleteEvent(action) {
    try {
        const { eid } = action.payload

        const resquest = yield call(deleteEventbyIdAPI, eid)
        console.log('respone delete event by id', resquest)
        if (resquest.error.code === 200) {
            yield put(actions.action.getListEvent(1, 10, 0))
            notification.success({
                message: 'Xoá sự kiện thành công',
            })
        } else {
            HandleErrorCode(resquest.error.code)
        }
    } catch (ex) {
        console.log('DeleteEventById Error : ', ex.message)
    }
}
function* saga_CreateNewEvent(action) {
    try {
        const { body } = action.payload

        const resquest = yield call(createNewEventAPI, body)
        console.log('respone create event ', resquest)
        if (resquest.error.code === 200) {
            yield put(actions.action.visibleCreateModal(false))
            yield put(actions.action.getListEvent(1, 10, 0))
            notification.success({
                message: 'Tạo mới sự kiện thành công',
            })
        } else {
            HandleErrorCode(resquest.error.code)
        }
    } catch (ex) {
        console.log('create event Error : ', ex.message)
    }
}
function* saga_getListEventQuerybyId(action) {
    try {
        const { lst } = action.payload

        const resquest = yield call(getListEventQuery, lst)
        if (resquest.error.code === 200) {
            yield put(actions.action.getListEventQueryIdDone(resquest.data))
        }
    } catch (ex) {
        console.log('get event by id query Error : ', ex.message)
    }
}
function* listen() {
    yield takeEvery(actions.type.GET_LIST_EVENT, saga_getListEvent)
    yield takeEvery(actions.type.GET_EVENT_BY_ID, saga_getEventById)
    yield takeEvery(actions.type.UPDATE_EVENT_BY_ID, saga_EditEvent)
    yield takeEvery(actions.type.DELETE_EVENT_BY_ID, saga_DeleteEvent)
    yield takeEvery(actions.type.CREATE_NEW_EVENT, saga_CreateNewEvent)
    yield takeEvery(
        actions.type.GET_LIST_EVENT_QUERY_BY_ID,
        saga_getListEventQuerybyId
    )
    yield takeEvery(actions.type.GET_OWNER_EVENT_INFO, saga_getOwnerInfo)
    yield takeEvery(actions.type.SEARCH_EVENT_BY_TEXT, saga_searchEventByText)
}

export default function* eventSaga() {
    yield all([fork(listen)])
}
